var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard"},[_c('Menu'),_c('WizardComp',{staticClass:"wizardView",attrs:{"data":_vm.product}}),_c('Footer'),_c('InfoStores'),_c('Copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }